export const styles = {
  container: { display: 'flex', alignItems: 'center', gap: '20px', cursor: 'pointer' },
};
